
















import { Component, Prop, PropSync, Vue } from "vue-property-decorator"

@Component
export default class BookingReportRiskProfileBodyMap extends Vue {
  @Prop() readonly bodyParts!: { id: string; severity: string | number }[]

  @Prop() readonly gender!: string

  @PropSync("isFront") isFrontSynced!: boolean

  @Prop() readonly syncKey!: string

  @PropSync("selectedBodyPart") selectedBodyPartSynced!: string
}
